module.exports = __webpack_public_path__ + "static/media/line-wave-bg.668fbb22.png";